/* eslint-disable no-new */
import Cookies from 'universal-cookie';

const cookies = new Cookies();
export const getCookies = (value = '') => cookies.get(value);
export const removeCookies = (value = '') => {
  new Promise((resolve) => {
    cookies.remove(value, { path: '/', sameSite: 'Strict' });
    resolve();
  });
};
export const setCookies = (key = '', value = '') => {
  cookies.set(key, value, {
    path: '/',
    sameSite: 'Strict',
  });
};

// localStorage helpers for USERPERMISSION
// Cookies have a hard 4 KB limit; a large permissions array silently gets
// dropped, which breaks ProtectedRoute and causes an immediate redirect to /login.
export const setPermissions = (permissions) => {
  try {
    localStorage.setItem('USERPERMISSION', JSON.stringify(permissions));
  } catch {
    // quota exceeded — permissions unchanged
  }
};

export const getPermissions = () => {
  try {
    const stored = localStorage.getItem('USERPERMISSION');
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const clearPermissions = () => {
  localStorage.removeItem('USERPERMISSION');
};
